import Slider from 'react-slick';

import styles from './About.module.scss';

const settings = {
  className: 'center',
  infinite: true,
  centerPadding: '60px',
  slidesToShow: 1,
  swipeToSlide: true,
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  cssEase: 'linear',
  pauseOnHover: false,
};

const settings_2 = {
  className: 'center',
  infinite: true,
  centerPadding: '60px',
  slidesToShow: 3,
  swipeToSlide: true,
  dots: false,
  arrows: false,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  cssEase: 'linear',
  pauseOnHover: false,
};

const About = () => {
  return (
    <section className={styles.about_container}>
      <div className={styles.about_inner}>
        <div className={styles.about_heading}>
          <h1>About Frizza</h1>
        </div>
        <div className={styles.about_details}>
          Frizza offers you the chance to earn money via Paytm and UPI with
          offerings like Daily App Offers, Reading News and Articles, Watching
          Videos, Daily Check-in, Referrals and much more
        </div>
        <div className='about_slider'>
          <Slider {...settings_2}>
            <div className='first_header'>
              <span>Daily Streak</span>
            </div>
            <div className='second_header'>
              <span>Earn wallet cash</span>
            </div>
            <div className='third_header'>
              <span>Transfer to your account</span>
            </div>
          </Slider>
        </div>
        <div className={styles.about_slider_pics}>
          <Slider {...settings}>
            <div>
              <img
                src="https://static.frizza.in/frizza/offer/banner/f10a8dd6-855f-4ff4-aa4f-2463c0aca30d.jpg"
                alt="Task"
                loading="lazy"
              />
            </div>
            <div>
              <img
                src="https://static.frizza.in/frizza/offer/banner/8d7a8ad3-99c9-422b-8596-c94b26411d61.jpg"
                alt="Earn wallet cash"
                loading="lazy"
              />
            </div>
            <div>
              <img
                src="https://static.frizza.in/frizza/offer/banner/be74f83b-3666-422a-abe0-e39c2f7f2978.png"
                alt="Transfer to your account"
                loading="lazy"
              />
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default About;
